import { render } from "./TraitShopCardButton.vue?vue&type=template&id=592f1bde"
import script from "./TraitShopCardButton.vue?vue&type=script&lang=js"
export * from "./TraitShopCardButton.vue?vue&type=script&lang=js"

import "./TraitShopCardButton.vue?vue&type=style&index=0&id=592f1bde&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__